import React from 'react';
import { useGoogleAnalytics } from '../../hooks/useGoogleAnalytics';

const AnalyticsManager = () => {
  useGoogleAnalytics();
  return null;
};

export default AnalyticsManager;

